import { render, staticRenderFns } from "./courseAssess.vue?vue&type=template&id=5055e0fd&scoped=true&"
import script from "./courseAssess.vue?vue&type=script&lang=js&"
export * from "./courseAssess.vue?vue&type=script&lang=js&"
import style0 from "./courseAssess.vue?vue&type=style&index=0&id=5055e0fd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5055e0fd",
  null
  
)

export default component.exports